import React, { useMemo, useEffect } from 'react';
import './BuyerTermsOfService.scss';
import { getGoogleDocsViewerUrl, getPdfUrl } from '../../../utils/pdfUrlHelper';
import { usePdfViewer } from '../../../custom-hooks/usePdfViewer';
import { useLegalDocument } from '../../../custom-hooks/useLegalDocument';
import { LegalDocumentType } from '../../../models/LegalDocuments/legal-document-type.enum';
import { useStateSelector } from '../../../store/selectors';
import { isIOS } from '../../../utils/deviceHelper';
import Loader from 'react-loaders';

const BuyerTermsOfService = () => {
    const axios = useStateSelector((state) => state.core.axios);
    const { documentUrl, isLoading } = useLegalDocument(
        LegalDocumentType.BuyersTermsOfService,
        axios
    );
    const isIOSDevice = useMemo(() => isIOS(), []);

    const { containerRef, isLoading: isPdfLoading } = usePdfViewer({
        pdfPath: documentUrl || '',
        getViewerUrl: getGoogleDocsViewerUrl,
    });

    const pdfUrl = useMemo(() => {
        if (!documentUrl) return '';
        return getPdfUrl(documentUrl);
    }, [documentUrl]);

    useEffect(() => {
        if (isIOSDevice && pdfUrl && !isLoading) {
            window.location.href = pdfUrl;
        }
    }, [isIOSDevice, pdfUrl, isLoading]);

    if (isLoading || !documentUrl) {
        return (
            <div className="buyer-terms-of-service-container">
                <div className="loading-container">
                    <Loader type="ball-scale-multiple" active />
                </div>
            </div>
        );
    }

    if (isIOSDevice) {
        return (
            <div className="buyer-terms-of-service-container">
                <div className="loading-container">
                    <Loader type="ball-scale-multiple" active />
                    <p style={{ marginTop: '1.5rem', fontSize: '1.1rem', color: '#666' }}>
                        Opening Buyer Terms of Service...
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="buyer-terms-of-service-container" ref={containerRef}>
            {isPdfLoading && (
                <div className="loading-container">
                    <Loader type="ball-scale-multiple" active />
                </div>
            )}
        </div>
    );
};

export default BuyerTermsOfService;
